import { create, all } from "mathjs";

export default {
    methods: {
        evtFormulation(ingredientArray, parameterArray) {
            //code for evt formulation algorithm
            let nutrientValue = [] //is an array of nutrient arrays (like test in Test.vue)
            let ingredientPrice = [] //is an array of ingredient price arrays (Like price in Test.vue)

            ingredientArray.forEach(ingredient => {
                let tempNutrientArray = []
                //push price of ingredient
                ingredientPrice.push([ingredient.price])

                //iterate through all the parameters
                parameterArray.forEach((parameter) => {
                    let parameterName = parameter.internal_name
                    tempNutrientArray.push(ingredient[parameterName])
                })
                nutrientValue.push(tempNutrientArray)
            })


            const math = create(all, {});
            let transposedTest = math.transpose(nutrientValue);
            let result1 = math.multiply(transposedTest, nutrientValue);
            let invertedResult = math.inv(result1);
            let invertedTransposedResult = math.multiply(invertedResult, transposedTest);
            let estimatedCostOfNutrients = math.multiply(invertedTransposedResult, ingredientPrice);
            let estimatedCostOfIngredients = math.multiply(nutrientValue, estimatedCostOfNutrients)

            return {
                estimatedCostOfIngredients: estimatedCostOfIngredients,
                estimatedCostOfNutrients: estimatedCostOfNutrients
            }
        }
    },
    data() {
        return {}
    }
}
